import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      // JQueries
      this.title    = json.title
      this.timeline = json.timeline
      this.primary  = json.primary
      this.chart    = json.chart
      this.legends  = json.legends

      this.filter   = json.filter
      this.sundries = json.sundries


      // Setting Timeline ------------------------------
      let unique = [ ...new Set(this.chartData.map(m => m[this.timeline.refCode])) ]
      this.timeline.axis = d3.scaleBand()
      .domain(unique)
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()
      
      unique.forEach((d,i)=> {
        
        let mid = this.timeline.axis(d) + this.timeline.band / 2
        this.timeline.xItems.push({
          name: d,
          sx: this.timeline.axis(d),
          mx: mid,
          ex: this.timeline.axis(d) + this.timeline.band,
          sum: this.chartData.find(f=> f[this.timeline.refCode] == d)[this.chart.tCode]
        })
      })


      // Setting Primary
      this.primary.max = this.gmx_maxBound5(d3.max(this.timeline.xItems, c => c.sum))

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])
    },


  }
}